module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Help1.5ec7f8c8.svg";